/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint-disable-next-line max-len */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state", "payload"] }] */

import api from '../../utils/api';

const baseURL = process.env.VUE_APP_BASE_URI;
const imageDir = '/patchcatalog/';
const customsDir = '/customs/';

const state = {
  patches: {
    catalog: [],
    featured: [],
    submissions: [],
  },
  tags: [],
  patch: {},
  imageDir: baseURL + imageDir,
  customsDir: baseURL + customsDir,
  loading: false,
  errorMessage: '',

  // SHOWCASE
  salesThreshold: 0,
  salesPeriod: 0, // in days from date submitted
};

const getters = {};

const mutations = {
  setCatalogPatches(state, patches) {
    state.patches.catalog = patches;
  },
  setFeaturedPatches(state, patches) {
    state.patches.featured = patches;
  },
  setSubmissions(state, patches) {
    state.patches.submissions = patches;
  },
  setSubmissionsConfig(state, submissionsConfig) {
    state.salesThreshold = submissionsConfig.salesThreshold;
    state.salesPeriod = submissionsConfig.salesPeriod;
  },
  setTags(state, tags) {
    state.tags = tags;
  },
  setPatch(state, patch) {
    state.patch = patch;
  },
  setLoading(state, { loading }) {
    state.loading = loading;
  },
  setErrorMessage(state, error) {
    state.errorMessage = error;
  },
};

const actions = {
  getAllPatches({ commit }, patchGroup) {
    commit('setLoading', { loading: true });
    let url = '';
    let commitType = '';
    switch (patchGroup) {
      case 'catalog':
        url = '/catalog/';
        commitType = 'setCatalogPatches';
        break;
      case 'featured':
        url = '/catalog/featured/';
        commitType = 'setFeaturedPatches';
        break;
      case 'submissions':
        url = '/submissions/';
        commitType = 'setSubmissions';
        break;
      default:
        url = '/catalog/';
        commitType = 'setCatalogPatches';
        break;
    }
    api
      .getData(url)
      .then((res) => {
        const patches = res.data;
        commit(commitType, patches);
        commit('setLoading', { loading: false });
      })
      .catch((error) => {
        commit('setLoading', { loading: false });
        commit('setErrorMessage', error);
      });
  },
  getTags({ commit }) {
    commit('setLoading', { loading: true });
    api
      .getData('/catalog/tags')
      .then((res) => {
        commit('setTags', res.data);
        commit('setLoading', { loading: false });
      })
      .catch((error) => {
        commit('setLoading', { loading: false });
        commit('setErrorMessage', error);
      });
  },
  getPatchById({ commit }, { id, patchGroup }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { loading: true });
      let url = '';
      switch (patchGroup) {
        case 'catalog':
          url = '/catalog/';
          break;
        case 'submissions':
          url = '/submissions/';
          break;
        default:
          url = '/catalog/';
          break;
      }
      api
        .getData(`${url}${id}`)
        .then((res) => {
          const patch = res.data;
          commit('setPatch', patch);
          commit('setLoading', { loading: false });
          resolve();
        })
        .catch((error) => {
          commit('setLoading', { loading: false });
          commit('setErrorMessage', error);
          reject();
        });
    });
  },
  getSubmissionsConfig({ commit }) {
    commit('setLoading', { loading: true });
    api
      .getData('/storefront/')
      .then((res) => {
        const { submissionsConfig } = res.data;
        commit('setSubmissionsConfig', submissionsConfig);
        commit('setLoading', { loading: false });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
